module.exports = __webpack_public_path__ + "improve.png?524019f5b15ab6eb8225a1c5ea80926d";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/improve.png
// module id = 341
// module chunks = 0